import { AXPlatform } from '@acorex/core/platform';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public themeMode: 'light' | 'dark' = 'light';

  // private _darkClass = 'ax-dark';
  // private _darkKey = 'DARK_MODE';

  constructor(private platform: AXPlatform) {}

  detectTheme() {
    const _mode = localStorage.getItem('MODE');
    if (_mode === 'dark') {
      this.enableDarkMode();
    } else {
      this.enableLightMode();
    }
  }

  switchMode() {
    if (this.themeMode !== 'light') {
      this.enableLightMode();
    } else {
      this.enableDarkMode();
    }
  }

  getMode() {
    return localStorage.getItem('MODE');
  }

  enableLightMode() {
    this.themeMode = 'light';
    localStorage.setItem('MODE', 'light');
    this.platform.switchLightMode();
  }
  enableDarkMode() {
    this.themeMode = 'dark';
    localStorage.setItem('MODE', 'dark');
    this.platform.switchDarkMode();
  }

  setTheme(themeColor: string) {
    const siteCss = document.getElementById('site-css');
    siteCss?.remove();
    document.head.innerHTML += `<link rel="stylesheet" href="./assets/themes/${themeColor}.css" type="text/css"/>`;
  }
}
